import { analyticSocialReachActions } from 'store/actions';
import { IAnalyticSocialReachMeta } from 'store/actions/analytics/ROI/socialReach';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<IAnalyticSocialReachMeta, GenericResponse>(
  analyticSocialReachActions,
);
